export const storeInSession = (key, value) =>
  window.sessionStorage.setItem(key, value);

export const getFromSession = key => window.sessionStorage.getItem(key);

export const deleteFromSession = key => window.sessionStorage.removeItem(key);

export const scopeWithKey = (key, scopeThunk) => {
  const value = getFromSession(key);
  if (value) {
    try {
      scopeThunk(value);
    } catch (error) {
      console.warn(
        'Error attempting to execute scoped session storage action',
        error
      );
    } finally {
      deleteFromSession(key);
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/storage.js